module.exports = __webpack_public_path__ + "static/media/logo-icon.ceb66bb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-icon.png
// module id = 73
// module chunks = 0